<template>
	<b-modal
		id="Attachmentdetail"
		ref="Attachmentdetail"
		hide-footer
		hide-header
		size="xl"
	>
	<img :src="imgurl"/>
	</b-modal>
</template>
<script>
export default {
	props: {
		imgurl: String
	},

}
</script>
